import { AnimaliaListingCardDTO } from '../../../../application/mappers/AnimaliaListingMapper';
import { animaliaListingDesignTokens } from '../shared/animalia-listing-design-tokens';
import '../cards/mv-animalia-listing-card';
import { MvAnimaliaListingCard } from '../cards/mv-animalia-listing-card';

export class MvAnimaliaListingGrid extends HTMLElement {
  private items: ReadonlyArray<AnimaliaListingCardDTO> = [];

  private detailQuery: Readonly<Record<string, string>> = {};

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  setItems(items: ReadonlyArray<AnimaliaListingCardDTO>): void {
    this.items = [...items];
    this.render();
    this.attachCards();
  }

  setDetailQuery(detailQuery: Readonly<Record<string, string>>): void {
    this.detailQuery = { ...detailQuery };
    this.attachCards();
  }

  connectedCallback(): void {
    this.render();
    this.attachCards();
  }

  private attachCards(): void {
    if (!this.shadowRoot) {
      return;
    }

    const cardElements = Array.from(
      this.shadowRoot.querySelectorAll('mv-animalia-listing-card'),
    ) as MvAnimaliaListingCard[];

    cardElements.forEach((card, index) => {
      const item = this.items[index];

      if (item) {
        card.setItem(item);
        card.setDetailQuery(this.detailQuery);
      }
    });
  }

  private render(): void {
    if (!this.shadowRoot) {
      return;
    }

    this.shadowRoot.innerHTML = `
      <style>
        ${animaliaListingDesignTokens}

        .card-grid {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 28px;
          align-items: stretch;
        }

        .card-grid > mv-animalia-listing-card {
          height: 100%;
        }

        @media (max-width: 980px) {
          .card-grid {
            grid-template-columns: 1fr;
          }
        }
      </style>

      <section class="card-grid">
        ${this.items.map(() => '<mv-animalia-listing-card></mv-animalia-listing-card>').join('')}
      </section>
    `;
  }
}

if (!customElements.get('mv-animalia-listing-grid')) {
  customElements.define('mv-animalia-listing-grid', MvAnimaliaListingGrid);
}
